// extracted by mini-css-extract-plugin
module.exports = {"divider":"Select-Divider--divider--3yl5a"};